import {
  Box,
  Chip,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AxiosInstance from "../../Config/AxiosInstance";
import APILIST from "../../Config/ApiList";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import NoDataImg from "../../Components/NoDataFound/NoDataFound";
import { useTimeSheet } from "../../Config/TimeSheetContext";
import { InfinitySpin } from "react-loader-spinner";
const CreateDailySheet = () => {
  const navigate = useNavigate();
  const { isLoading, timeSheetUserDetails } = useTimeSheet();
  const [loading, setLoading] = useState(false);
  const [clientDailySheetList, setClientDailySheetList] = useState([]);
  useEffect(() => {
    if (timeSheetUserDetails?.user_details?.id) {
      getCreateUsersList(timeSheetUserDetails?.user_details?.id);
    }
  }, [timeSheetUserDetails?.user_details?.id]);
  const getCreateUsersList = async (id) => {
    setLoading(true);
    try {
      const response = await AxiosInstance.get(APILIST.GET_LEAD_CLIENT, {
        params: {
          caregiver_id: id,
        },
      });
      if (response && response?.data?.s) {
        setClientDailySheetList(response?.data?.r);
        setLoading(false);
      } else {
        setClientDailySheetList([]);
        setLoading(false);
      }
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };
  const getOnboardingStatusColor = (status) => {
    switch (status) {
      case -1:
        return { label: "Declined", color: "#F44336" };
      case 0:
        return { label: "Pending", color: "#FFC107" };
      case 1:
        return { label: "In Progress", color: "#2196F3" };
      case 2:
        return { label: "Called", color: "#9C27B0" };
      case 3:
        return { label: "Conduct Assessment", color: "#A0522D" };
      case 4:
        return { label: "Started", color: "#4CAF50" };
    }
  };
  // lead_status :- 0:Pending | 1:Verified
  // onboardig_status:- -1:Decline | 0:Pending | 1:In Progress | 2:Called | 3:Conduct Assessment | 4:Joined
  return isLoading ? (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: { xs: "100%" },
        minHeight: "100vh",
        background: "rgba(13, 18, 41, 1)",
      }}
    >
      <InfinitySpin
        visible={true}
        width="200"
        color="#4fa94d"
        ariaLabel="infinity-spin-loading"
      />
    </Box>
  ) : (
    <Fragment>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: { xs: "100%" },
          minHeight: "100vh",
          background: "rgba(13, 18, 41, 1)",
        }}
      >
        <Box
          sx={{
            background: "rgba(37, 42, 62, 1)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            position: "fixed",
            top: "0px",
            left: "0px",
            right: "0px",
            padding: "10px 10px",
            boxSizing: "border-box",
            zIndex: "10",
            width: "100%",
          }}
        >
          <Box
            sx={{
              width: "10%",
            }}
          >
            <IconButton
              sx={{
                width: "42px",
                height: "42px",
                borderRadius: "50%",
                background: "rgba(59, 63, 81, 1)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                outline: "none",
                border: "none",
                cursor: "pointer",
                ":hover": {
                  background: "rgba(59, 63, 81, 1)",
                },
              }}
              onClick={() => navigate(-1)}
            >
              <img
                src="/back-arrow.webp"
                alt="back-arrow"
                style={{
                  width: "18px",
                  height: "18px",
                }}
              />
            </IconButton>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "auto",
              flex: 1,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                color: "rgba(255, 255, 255, 1)",
                fontSize: "22px",
                fontWeight: "600",
                fontFamily: "Poppins",
                textAlign: "center",
                width: "100%",
              }}
            >
              Lead Status
            </Typography>
          </Box>
          <Box
            sx={{
              width: "10%",
            }}
          ></Box>
        </Box>
        <Box
          sx={{
            width: "100%",
            maxWidth: "100%",
            padding: "0px 15px",
            boxSizing: "border-box",
          }}
        >
          <Box
            sx={{
              width: "100%",
              paddingTop: "62px",
              boxSizing: "border-box",
              overflowX: "auto",
            }}
          >
            <Table sx={{}}>
              <TableHead
                sx={{
                  background: "rgba(107, 207, 207, 1)",
                  // position: "sticky",
                  // top: 0,
                  // zIndex: 1,
                }}
              >
                <TableRow>
                  <TableCell
                    sx={{
                      fontWeight: "500",
                      fontSize: "15px",
                      color: "rgba(0, 0, 0, 0.8)",
                      fontFamily: "Poppins",
                      padding: "15px 10px",
                      background: "rgba(107, 207, 207, 1)",
                      border: "1px solid #000",
                      textWrap: "nowrap",
                      textAlign: "center",
                    }}
                  >
                    #
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "500",
                      fontSize: "15px",
                      color: "rgba(0, 0, 0, 0.8)",
                      fontFamily: "Poppins",
                      padding: "15px 10px",
                      background: "rgba(107, 207, 207, 1)",
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    Date
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "500",
                      fontSize: "15px",
                      color: "rgba(0, 0, 0, 0.8)",
                      fontFamily: "Poppins",
                      padding: "15px 10px",
                      background: "rgba(107, 207, 207, 1)",
                      border: "1px solid #000",
                      textWrap: "nowrap",
                      textAlign: "center",
                    }}
                  >
                    New Lead
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "500",
                      fontSize: "15px",
                      color: "rgba(0, 0, 0, 0.8)",
                      fontFamily: "Poppins",
                      padding: "15px 10px",
                      background: "rgba(107, 207, 207, 1)",
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    Lead Type
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "500",
                      fontSize: "15px",
                      color: "rgba(0, 0, 0, 0.8)",
                      fontFamily: "Poppins",
                      padding: "15px 10px",
                      background: "rgba(107, 207, 207, 1)",
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    Verified
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "500",
                      fontSize: "15px",
                      color: "rgba(0, 0, 0, 0.8)",
                      fontFamily: "Poppins",
                      padding: "15px 10px",
                      background: "rgba(107, 207, 207, 1)",
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    Status
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  [...Array(5)].map((_, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        background: "rgba(73, 80, 106, 1)",
                        borderRadius: "15px",
                        marginBottom: "10px",
                      }}
                    >
                      <TableCell
                        sx={{
                          fontWeight: "400",
                          fontSize: "14px",
                          color: "#fff",
                          fontFamily: "Poppins",
                          padding: "10px 10px",
                          border: "1px solid #ddd",
                        }}
                      >
                        <Skeleton width={50} />
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "400",
                          fontSize: "14px",
                          color: "#fff",
                          fontFamily: "Poppins",
                          padding: "10px 10px",
                          border: "1px solid #ddd",
                        }}
                      >
                        <Skeleton width={100} />
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "400",
                          fontSize: "14px",
                          color: "#fff",
                          fontFamily: "Poppins",
                          padding: "10px 10px",
                          border: "1px solid #ddd",
                        }}
                      >
                        <Skeleton width={100} />
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "400",
                          fontSize: "14px",
                          color: "#fff",
                          fontFamily: "Poppins",
                          padding: "10px 10px",
                          border: "1px solid #ddd",
                        }}
                      >
                        <Skeleton width={150} />
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "400",
                          fontSize: "14px",
                          color: "#fff",
                          fontFamily: "Poppins",
                          padding: "10px 10px",
                          border: "1px solid #ddd",
                        }}
                      >
                        <Skeleton width={80} />
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "400",
                          fontSize: "14px",
                          color: "#fff",
                          fontFamily: "Poppins",
                          padding: "10px 10px",
                          border: "1px solid #ddd",
                        }}
                      >
                        <Skeleton width={80} />
                      </TableCell>
                    </TableRow>
                  ))
                ) : clientDailySheetList?.length > 0 ? (
                  clientDailySheetList?.map((row, index) => (
                    <TableRow
                      key={row.id}
                      sx={{
                        background: "rgba(73, 80, 106, 1)",
                        borderRadius: "15px",
                        marginBottom: "10px",
                      }}
                    >
                      <TableCell
                        sx={{
                          fontWeight: "400",
                          fontSize: "14px",
                          color: "#fff",
                          fontFamily: "Poppins",
                          padding: "10px 10px",
                          border: "1px solid #ddd",
                          textAlign: "center",
                        }}
                      >
                        {index + 1}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "400",
                          fontSize: "14px",
                          color: "#fff",
                          fontFamily: "Poppins",
                          padding: "10px 10px",
                          border: "1px solid #ddd",
                          textAlign: "center",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gridGap: "10px",
                          }}
                        >
                          {moment(row?.created_at).format("MM/DD/YYYY") || "-"}
                        </Box>
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "400",
                          fontSize: "14px",
                          color: "#fff",
                          fontFamily: "Poppins",
                          padding: "10px 10px",
                          border: "1px solid #ddd",
                          textAlign: "center",
                        }}
                      >
                        {row?.name || "-"}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "400",
                          fontSize: "14px",
                          color: "#fff",
                          fontFamily: "Poppins",
                          padding: "10px 10px",
                          border: "1px solid #ddd",
                          textAlign: "center",
                        }}
                      >
                        { row?.type === 1 ? "Client" : "Employee" || "-"}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "400",
                          fontSize: "14px",
                          color: "#fff",
                          fontFamily: "Poppins",
                          padding: "10px 10px",
                          border: "1px solid #ddd",
                          textAlign: "center",
                        }}
                      >
                        <Chip
                          label={row.lead_status === 0 ? "Pending" : "Verified"}
                          sx={{
                            backgroundColor:
                              row.lead_status === 0 ? "orange" : "green",
                          }}
                        />
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "400",
                          fontSize: "14px",
                          color: "#fff",
                          fontFamily: "Poppins",
                          padding: "10px 10px",
                          border: "1px solid #ddd",
                          textAlign: "center",
                        }}
                      >
                        <Chip
                          label={
                            getOnboardingStatusColor(row?.onboardig_status)
                              ?.label
                          }
                          sx={{
                            backgroundColor: getOnboardingStatusColor(
                              row.onboardig_status
                            )?.color,
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={5}>
                      <NoDataImg />
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Box>
        </Box>
      </Box>
    </Fragment>
  );
};

export default CreateDailySheet;
